import {
	PLAYERS_FETCH,
	PLAYERS_FETCH_SUCCESS,
	PLAYERS_FETCH_FAIL,
	PLAYERS_TOGGLE_EDIT,
	PLAYERS_EDIT_AVATAR_TEXT_CHANGE,
	PLAYERS_EDIT_FNAME_TEXT_CHANGE,
	PLAYERS_EDIT_SURNAME_TEXT_CHANGE,
	PLAYERS_EDIT_INITAL_TEXT_CHANGE,
	PLAYERS_EDIT_POSITION_CHANGE,
	PLAYERS_EDIT_SQUAD_NUM_TEXT_CHANGE,
	PLAYERS_UPDATE_SUCCESS,
	PLAYERS_UPDATE_FAIL,
	PLAYERS_NEW_SUCCESS,
	PLAYERS_DELETE_SUCCESS,
	PLAYERS_DELETE_FAIL,
} from '../actions/types';

const INITIAL_STATE = {
	loading: false,
	list: {},
	listByID: [],
	errorText: '',
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case PLAYERS_FETCH:
			return { ...state, loading: true, errorText: '' };

		case PLAYERS_FETCH_SUCCESS:
			return { ...state, loading: false, list: action.payload, listByID: action.listByID };

		case PLAYERS_FETCH_FAIL:
			return { ...state, loading: false, errorText: action.payload };

		case PLAYERS_TOGGLE_EDIT:
			const copyToggleEdit = Object.assign({}, state.list);
			copyToggleEdit[action.id].readOnly = !state.list[action.id].readOnly;
			copyToggleEdit[action.id].onChange = state.list[action.id];
			return { ...state, list: copyToggleEdit };

		case PLAYERS_EDIT_AVATAR_TEXT_CHANGE:
			const copyAvatarTextChange = Object.assign({}, state.list);
			copyAvatarTextChange[action.id].onChange = {
				...copyAvatarTextChange[action.id].onChange,
				playerAvatar: action.payload,
				uploaded: true,
			};
			return { ...state, list: copyAvatarTextChange };
		case PLAYERS_EDIT_FNAME_TEXT_CHANGE:
			const copyFnameTextChange = Object.assign({}, state.list);
			copyFnameTextChange[action.id].onChange = {
				...copyFnameTextChange[action.id].onChange,
				firstName: action.payload,
			};
			return { ...state, list: copyFnameTextChange };
		case PLAYERS_EDIT_SURNAME_TEXT_CHANGE:
			const copySurnameTextChange = Object.assign({}, state.list);
			copySurnameTextChange[action.id].onChange = {
				...copySurnameTextChange[action.id].onChange,
				surname: action.payload,
			};
			return { ...state, list: copySurnameTextChange };
		case PLAYERS_EDIT_INITAL_TEXT_CHANGE:
			const copyInitialTextChange = Object.assign({}, state.list);
			copyInitialTextChange[action.id].onChange = {
				...copyInitialTextChange[action.id].onChange,
				initial: action.payload,
			};
			return { ...state, list: copyInitialTextChange };
		case PLAYERS_EDIT_POSITION_CHANGE:
			const copyPositionTextChange = Object.assign({}, state.list);
			copyPositionTextChange[action.id].onChange = {
				...copyPositionTextChange[action.id].onChange,
				position: action.payload.position,
				positionIndex: action.payload.positionIndex,
			};
			return { ...state, list: copyPositionTextChange };
		case PLAYERS_EDIT_SQUAD_NUM_TEXT_CHANGE:
			const copySquadNumTextChange = Object.assign({}, state.list);
			copySquadNumTextChange[action.id].onChange = {
				...copySquadNumTextChange[action.id].onChange,
				squadNumber: action.payload,
			};
			return { ...state, list: copySquadNumTextChange };

		case PLAYERS_UPDATE_SUCCESS:
			const copyUpdate = Object.assign({}, state.list);
			copyUpdate[action.id] = {
				...action.payload,
				onChange: action.payload,
				readOnly: true,
			};
			return { ...state, list: copyUpdate };

		case PLAYERS_UPDATE_FAIL:
			const copyUpdateFail = Object.assign({}, state.list);
			copyUpdateFail[action.id] = {
				...copyUpdateFail[action.id],
				error: action.error,
				errorText: action.errorText,
			};
			return { ...state, list: copyUpdateFail };

		case PLAYERS_NEW_SUCCESS:
			const copyNew = Object.assign({}, state.list);
			let copyNewById = state.listByID.slice();
			copyNew[action.id] = {
				...copyNew[action.id],
				...action.payload,
				readOnly: true,
				onChange: action.payload.name,
			};
			copyNewById = [...copyNewById, action.id];
			return { ...state, list: copyNew, listByID: copyNewById.sort((a, b) => a - b) };

		case PLAYERS_DELETE_SUCCESS:
			const copyDeleteById = state.listByID.filter(v => v !== action.id);
			const copyDelete = Object.keys(state.list).reduce((obj, key) => {
				if (parseInt(key, 10) !== action.id) {
					return { ...obj, [key]: state.list[key] };
				}
				return obj;
			}, {});
			return { ...state, list: copyDelete, listByID: copyDeleteById };
		case PLAYERS_DELETE_FAIL:
			const copyDeleteFail = Object.assign({}, state.list);
			copyDeleteFail[action.id] = {
				...copyDeleteFail[action.id],
				error: action.error,
				errorText: action.errorText,
			};
			return { ...state, list: copyDeleteFail };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/PlayerReducer.js